// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___2YvNj","addText":"AddFilterBox__addText___1ujAu","addFilterContainer":"AddFilterBox__addFilterContainer___3-icw","addIcon":"AddFilterBox__addIcon___3pUhz"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/invoices/components/AddFilterBox.scss
// module id = 1706
// module chunks = 0